import i18n from 'i18n/i18n';

export enum ConditionType {
	NORMAL = 'NORMAL',
	LOW_RISK = 'LOW_RISK',
	MEDIUM_RISK = 'MEDIUM_RISK',
	HIGH_RISK = 'HIGH_RISK',
	IMMINENT_HIGH_RISK = 'IMMINENT_HIGH_RISK',
}

const CONDITION_TYPE_I18N_KEYS: Record<ConditionType, string> = {
	[ConditionType.NORMAL]: 'pages.thermography.conditionType.normal',
	[ConditionType.LOW_RISK]: 'pages.thermography.conditionType.lowRisk',
	[ConditionType.MEDIUM_RISK]: 'pages.thermography.conditionType.mediumRisk',
	[ConditionType.HIGH_RISK]: 'pages.thermography.conditionType.highRisk',
	[ConditionType.IMMINENT_HIGH_RISK]: 'pages.thermography.conditionType.imminentHighRisk',
};

export const ConditionTypeLabel = new Proxy(CONDITION_TYPE_I18N_KEYS as Record<ConditionType, string>, {
	get(target, prop: string | symbol) {
		if (typeof prop === 'symbol') return (target as any)[prop];
		const key = target[prop as ConditionType];
		return key ? i18n.t(key, { ns: 'translation' }) : undefined;
	}
}) as Record<ConditionType, string>;
